var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HomePage h-full w-full text-lg"},[_c('DropMenu'),_c('TopMenu',{ref:"TopMenu"}),_c('HomePage'),_c('ExperimentsPage',{ref:"experiment"}),_c('examplesPage',{ref:"examples"}),_c('ContactPage'),_c('BibtexView'),_c('FooterPart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }